import * as Yup from 'yup';
import { EMAIL_REGEXP } from '../regexp';

export const subscribeEmailShemas = Yup.object().shape({
  email: Yup.string().matches(EMAIL_REGEXP, 'yourEmailValidateError').required(),
});
